'use strict'
import * as React from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import { getAuthority } from '../services/auth/AuthorityService'
import { ToastProvider } from '../_components/Toast'
import { ModalProvider } from '../_components/Modal'
import { fetchSecuritiesConfig } from './master/securitiesReportInfo/extra/services'
import { getCurrentFiscalYear } from './master/securitiesReportInfo/extra/helpers'
import { fetchFilter } from '../_components/FilterComponent/filters/services'

import '../assets/css/vendor/normalize.css'
import '../assets/css/vendor/animate.min.css'
import '../assets/css/vendor/hamburgers.css'
import '../assets/icon/style.css'
import '../assets/css/style.css'
import '../assets/js/tailwindcss.js'
import '../assets/js/adobe_fonts.js'
import '../assets/js/script.js'

/**
 * @function runWarmStartupForSlowTasks ラムダを起動させるための関数
 * @param {import('redux').Store} store
 */
const runWarmStartupForSlowTasks = async (store) => {
  const WARMUP_KEY = 'chrofyLastWarmupTime'
  const FIFTEEN_MINUTES = 15 * 60 * 1000
  const now = Date.now()

  const lastWarmup = localStorage.getItem(WARMUP_KEY)
  if (lastWarmup && now - Number(lastWarmup) < FIFTEEN_MINUTES) {
    return
  }

  localStorage.setItem(WARMUP_KEY, now)

  try {
    const state = store.getState()

    const fiscalYear = getCurrentFiscalYear(state.company.accPeriod, true)

    const securitiesReportPromise = () => fetchSecuritiesConfig(store, fiscalYear)
    const filterPromise = () =>
      fetchFilter(
        '1.1.2',
        {
          mode: state.analysis.mode,
          corporationNumber: state.company.corporationNumber
        },
        {}
      )

    await Promise.all([securitiesReportPromise(), filterPromise()]).catch()
  } catch (error) {
    console.warn(error)
  }
}

const Contents = ({ Component }) => {
  const [isLoaded, setIsLoaded] = React.useState(false)
  const state = useSelector((state) => state)
  const dispatch = useDispatch()
  const store = useStore()

  React.useEffect(() => {
    setIsLoaded(false)
    init()
  }, [])

  const init = async () => {
    const authority = await getAuthority(state.analysis.mode, state.company.corporationNumber, state.user.sub)
    dispatch({
      type: 'SET_AUTHORITY',
      payload: {
        authority: authority
      }
    })
    setIsLoaded(true)

    runWarmStartupForSlowTasks(store).catch()
  }

  // 初期表示時に「leader-line-new」のLineを削除する
  const lines = document.querySelectorAll('.leader-line')
  if (lines) {
    lines.forEach((e) => e.remove())
  }

  /** 描画処理 */
  if (!isLoaded) {
    return null
  }
  return (
    <div>
      <ToastProvider>
        <ModalProvider>
          <Component />
        </ModalProvider>
      </ToastProvider>
    </div>
  )
}

export default Contents
